import { Link, type To, useLocation } from 'react-router';

export function BreadCrumbs() {
  const { search } = useLocation();

  return (
    <>
      <BreadCrumb url={{ pathname: '/pay/account', search }}>
        iwocaPay Dashboard{' '}
      </BreadCrumb>
      <BreadCrumb isFinal>Supplier directory</BreadCrumb>
    </>
  );
}

function BreadCrumb({
  children,
  url,
  isFinal,
}: {
  children: React.ReactNode;
  url?: To;
  isFinal?: boolean;
}) {
  return (
    <span className="flex gap-m">
      {url ? (
        <Link to={url} className="text-s font-reg !text-primary-40 underline">
          {children}
        </Link>
      ) : (
        <span className="text-s font-reg">{children}</span>
      )}
      {!isFinal && <span>/</span>}
    </span>
  );
}
